export default "/_next/static/images/service-training-desktop-2x-806bdd40ad67ba5fa870b3915610b065.jpg";